import * as React from 'react'

import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react'
import { action, makeObservable } from 'mobx'
import { selectors } from 'react-virtualized-tree'

import { IDeliveryTreeNode } from '~/client/src/shared/models/IDeliveryTreeNode'

import FileInputBase from '../FileInput/FileInput'
import TableSeparators from '../TableSeparators'

const { getNodeRenderOptions, updateNode } = selectors

const LEVEL_OFFSET = 18

interface IProps {
  node: IDeliveryTreeNode
  index: string | number
  measure: () => void
  onChange: (node: any) => void
  startViewDate: Date
  className?: string
  changeContainerExpandState?: (id: string, value: boolean) => void
  isContainerUpdateEnabled?: boolean
  FileInputType: typeof FileInputBase
  shouldRenderSeparators?: boolean
}

export default class DeliveryNodeRenderer extends React.Component<IProps> {
  public constructor(props: IProps) {
    super(props)
    makeObservable(this)
  }

  public componentDidMount() {
    this.props.measure()
  }

  public render() {
    const {
      className = '',
      children,
      shouldRenderSeparators,
      node,
    } = this.props
    const level = node.level - 1

    return (
      <div className={`row content ${className}`} onClick={this.handleChange}>
        {shouldRenderSeparators && (
          <TableSeparators
            level={level}
            className="no-grow br-palette-grey full-height"
            marginLeft={LEVEL_OFFSET}
          />
        )}
        {this.handle}
        {children}
      </div>
    )
  }

  private get handle(): JSX.Element {
    const { node } = this.props
    const { hasChildren, isExpanded } = getNodeRenderOptions(node)

    if (!hasChildren) {
      return null
    }

    const HandleIcon = isExpanded ? ChevronDownIcon : ChevronRightIcon

    return <HandleIcon size={16} className="ml10 mr10 no-grow handle-icon" />
  }

  @action.bound
  private handleChange() {
    const { onChange, node, index } = this.props
    const { isExpanded, hasChildren } = getNodeRenderOptions(node)

    if (!hasChildren) {
      return
    }

    onChange({ ...updateNode(node, { expanded: !isExpanded }), index })
  }
}
